import { Component, inject, input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'atlas-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
  standalone: false,
})
export class ModalHeaderComponent {
  dialog = inject(MatDialogRef);
  hideCloseBtn = input<boolean>(false);

  close(): void {
    this.dialog.close();
  }
}
